module.exports = __webpack_public_path__ + "static/benchmarking 4-822eb5e21046fd3fd5abb6849fa2763d.png";